export default "/images/vendor/flag-icon-css/flags/1x1/vi.svg?75fc073be5d2be7053e29f13d7426abd";